import React from "react";

function OutdatedUiVersion() {

    return (
        <>
            <div className="row">
                <div className="col-12">

                    <div>
                        <h2>An error occurred because the software version you are using is outdated. Your application has not been submitted or saved. Please follow the instructions below or call our Customer Service at 1-866-449-4514.</h2>
                        <br />

                        <h2>For Google Chrome</h2>
                        <ol>
                            <li>Click the <strong>three dots</strong> in the upper-right corner.</li>
                            <li>Select <strong>Settings → Privacy and Security</strong>.</li>
                            <li>Choose <strong>Clear browsing data</strong>.</li>
                            <li>Under the <strong>Basic</strong> or <strong>Advanced</strong> tab, select <strong>Cached images and files</strong> (make sure this option is checked).</li>
                            <li>Click <strong>Clear data</strong>, then refresh the page.</li>
                        </ol>

                        <hr />
                        
                        <h2>For Safari (Mac/iOS)</h2>
                        <ol>
                            <li>Open <strong>Settings</strong> (or choose the Safari menu on Mac).</li>
                            <li>Go to <strong>Safari → Advanced → Website Data</strong>.</li>
                            <li><strong>On Mac:</strong> open <strong>Safari → Preferences → Privacy → Manage Website Data</strong>.</li>
                            <li>Select <strong>Remove All</strong> to clear cached files and images.</li>
                            <li>Confirm, then refresh the browser.</li>
                        </ol>

                        <hr />

                        <h2>For Microsoft Edge</h2>
                        <ol>
                            <li>Click the <strong>three dots</strong> in the upper-right corner.</li>
                            <li>Select <strong>Settings</strong>.</li>
                            <li>Click <strong>Clear browsing data</strong> button.</li>
                            <li>On the <strong>Time range</strong> dropdown, select <strong>All time</strong> option.</li>
                            <li>Check the boxes for <strong>Cookies and other site data</strong> and <strong>Cached images and files</strong>, leave the others unchecked.</li>
                            <li>Click <strong>Clear now</strong>, then refresh the page.</li>
                        </ol>

                        <hr />

                        <p><strong>Have a Question? Call Customer Service at 1-866-449-4514</strong></p>

                        <p><strong>Hours of Operation:</strong><br/>
                            Monday – Friday: 7:00 AM – 12:00 AM<br/>
                            Saturday – Sunday: 8:00 AM – 8:00 PM<br/>
                            Eastern Standard Time (EST)
                        </p>
                    </div>

                </div>
            </div>
        </>
    )
}

export default OutdatedUiVersion;